let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lh6fT")).then(() => parcelRequire('f9aTe'));